export const GAME_PACK = {
  starterTop: {
    label: "Top Games",
    filter: "starter_top_games",
  },
  starterEditor: {
    label: "Editor Picks",
    filter: "starter_editor_picks",
  },
  starterBest: {
    label: "Best Selling",
    filter: "starter_best_selling",
  },
  starterAll: {
    label: "All Games",
    filter: "Starter",
  },
  ultimateTop: {
    label: "Top Games",
    filter: "ultimate_top_games",
  },
  ultimateEditor: {
    label: "Editor Picks",
    filter: "ultimate_editor_picks",
  },
  ultimateBest: {
    label: "Best Selling",
    filter: "ultimate_best_selling",
  },
  ultimateAll: {
    label: "All Games",
    filter: "BLACKNUT",
  },
  byogTop: {
    label: "Top Games",
    filter: "byog_top_games",
  },
  byogEditor: {
    label: "Editor Picks",
    filter: "byog_editor_picks",
  },
  byogBest: {
    label: "Best Selling",
    filter: "byog_best_selling",
  },
  byogDemo: {
    label: "Demo Games",
    filter: "byog_demo",
  },
  byogAll: {
    label: "All Games",
    filter: "BYOG",
  },
  PID: {
    label: "All Games",
    filter: "PID",
  },
};

export const GAME_CARD_RATIO = 427 / 320;

export const VIDEO_CARD_RATIO = 270 / 480;

export const STEAM_LOGIN_PAGE = "https://store.steampowered.com/join";
